/* eslint-disable prefer-reflect */
import { AppEnum } from '.';
import { ServiceTransport } from '@tencent/s2-client-vue-lib';
import qs from 'qs';
import { ServiceImportAndExport } from './ServiceImportAndExport';

/**
 * 集团商户号接口文档
 * http://dev-gmmp.woa.com/api/doc.html
 *
 * @class ServiceCas
 * @extends {ServiceImportAndExport}
 */
class ServiceCas extends ServiceImportAndExport {
	/** constructor */
	constructor() {
		super(AppEnum.CASE_V3);
	}

	/** 获取用户信息 */
	public async getProfile(config: any = {}): Promise<any> {
		if (config) {
			config.headers = {
				'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
			};
		}

		// return {
		// 	code: 200,
		// 	msg: 'success',
		// 	data: {
		// 		user: {
		// 			id: 74864,
		// 			name: 'zhongyhuang',
		// 			fullName: 'zhongyhuang(黄仲洋)',
		// 			email: 'zhongyhuang@tencent.com',
		// 			avatar: null,
		// 			deptId: 5981,
		// 			deptName: 'S系统财务管理',
		// 			bgId: 2233,
		// 			bgName: 'S2职能系统－财经线',
		// 			roles: [{ code: 'PUBLIC_ROLE', name: '公共角色' }],
		// 			permissions: [
		// 				{ code: 'GMMP', permission: 'ROOT', type: 'MENU' },
		// 				{ code: 'Home', permission: 'NONE', type: 'MENU' },
		// 				{ code: 'PersonalWorkstation', permission: 'NONE', type: 'MENU' }
		// 			]
		// 		},
		// 		menus: [
		// 			{ codeName: { code: 'Home', name: '首页' }, url: '/', order: 1, icon: '', target: '_self', visible: true, subMenus: null },
		// 			{
		// 				codeName: { code: 'PersonalWorkstation', name: '个人工作台' },
		// 				url: '/MyWorkspace',
		// 				order: 2,
		// 				icon: '',
		// 				target: '_self',
		// 				visible: true,
		// 				subMenus: null
		// 			}
		// 		]
		// 	}
		// };
		return await this.get('/getPageHeader', config);
	}

	/**
	 * 获取待办/已办数量
	 *
	 * @returns
	 *
	 * @memberOf ServiceDecision
	 */
	public async getTodoNum(data: any, config = {}): Promise<any> {
		return await this.post('/todoService/getSingleTodoAndDoneNum', data, config);
		// return await this.post('/testService/getTodoAndDoneNum', data, config);
	}

	/**
	 * 获取待办/已办明细
	 *
	 * @returns
	 *
	 * @memberOf ServiceDecision
	 */
	public async getTodoDetail(data: any, config = {}): Promise<any> {
		return await this.post('/todoService/getTodoAndDoneDetail', data, config);
		// return await this.post('/testService/getTodoAndDoneDetail', data, config);
	}

	/**
	 * 查询已办，待办
	 *
	 * @returns
	 *
	 * @memberOf ServiceDecision
	 */
	public async searchTodoAndDoneDetail(data: any, config = {}): Promise<any> {
		return await this.post('/todoService/searchTodoAndDoneDetail', data, config);
		// return await this.post('/testService/searchTodoAndDoneDetail', data, config);
	}

	/**
	 * 获取用户信息和账户信息
	 *
	 * @returns
	 *
	 * @memberOf ServiceDecision
	 */
	public async getUserAndAccountInfo(data: any, config = {}): Promise<any> {
		return await this.get('/userService/getUserAndAccount', data);
	}

	/**
	 * 获取当前用户信息
	 *
	 * @returns
	 *
	 * @memberOf ServiceDecision
	 */
	public async getUserManagement(data: any, config = {}): Promise<any> {
		return await this.get('/userService/getUserManagement', data);
	}

	/**
	 * 获取供应商系统公告信息
	 *
	 * @returns
	 *
	 * @memberOf ServiceDecision
	 */
	public async getAnnouncementB(data: any): Promise<any> {
		return await this.get('/index/getAnnouncement', data);
	}

	/**
	 * 获取供应商企业信息
	 *
	 * @returns
	 *
	 * @memberOf ServiceDecision
	 */
	public async getEnterpriseInfo(data: any, config = {}): Promise<any> {
		return await this.get('/supplierService/getEnterpriseInfo', data);
	}

	/**
	 * 获取供应商自助注册链接
	 *
	 * @returns
	 *
	 * @memberOf ServiceDecision
	 */
	public async getSupplierRegisterUrl(config = {}): Promise<any> {
		return await this.get('/index/getSupplierRegisterUrl');
	}

	/**
	 * 创建信用申请
	 *
	 * @returns
	 *
	 * @memberOf ServiceDecision
	 */
	public async createApply(data: any, config = {}): Promise<any> {
		return await this.post('/apply/createApply', data, config);
	}

	/**
	 * 动态获取各下拉选择初始化
	 *
	 * @returns
	 *
	 * @memberOf ServiceDecision
	 */
	public async getSelectItem(data: any): Promise<any> {
		return await this.get('/common/getSelectItem', data);
	}

	/**
	 * 评估指标-批量上传预览
	 *
	 * @returns
	 *
	 * @memberOf ServiceDecision
	 */
	public async indexPreview(data: any, config = { headers: {} }): Promise<any> {
		config.headers = Object.assign(config.headers, {
			'Content-Type': 'multipart/form-data'
		});

		return await this.post('/index/preview', data, config);
	}

	/**
	 * 指标预览结果查询
	 *
	 * @returns
	 *
	 * @memberOf ServiceDecision
	 */
	public async getPreviewResult(modelId: string, batchId: string): Promise<any> {
		return await this.get(`/index/getPreviewResult/${modelId}/${batchId}`);
	}

	/**
	 * 评估指标-批量上传提交
	 *
	 * @returns
	 *
	 * @memberOf ServiceDecision
	 */
	public async submit(data: any, config = {}): Promise<any> {
		return await this.post('/index/submit', data, config);
	}

	/**
	 * 评估指标-指标分页查询index/confirm
	 *
	 * @returns
	 *
	 * @memberOf ServiceDecision
	 */
	public async page(data: any, config = {}): Promise<any> {
		return await this.post('/index/page', data, config);
	}

	/**
	 * 评估指标-指标单确认
	 *
	 * @returns
	 *
	 * @memberOf ServiceDecision
	 */
	public async confirm(data: any, config = {}): Promise<any> {
		return await this.post('/index/confirm', data, config);
	}

	/**
	 * 评估指标-指标单删除（失效）
	 *
	 * @returns
	 *
	 * @memberOf ServiceDecision
	 */
	public async invalid(data: any, config = {}): Promise<any> {
		return await this.post('/index/invalid', data, config);
	}

	/**
	 * 评估指标-指标单详情
	 *
	 * @returns
	 *
	 * @memberOf ServiceDecision
	 */
	public async detail(platformId: string, indexId: string): Promise<any> {
		return await this.get(`/index/detail/${platformId}/${indexId}`);
	}

	/**
	 * 评估指标-指标单详情
	 *
	 * @returns
	 *
	 * @memberOf ServiceDecision
	 */
	public async edit(data: any, config = {}): Promise<any> {
		return await this.post('/index/edit', data, config);
	}

	/**
	 * 评估指标-指标单笔录入
	 *
	 * @returns
	 *
	 * @memberOf ServiceDecision
	 */
	public async add(data: any, config = {}): Promise<any> {
		return await this.post('/index/add', data, config);
	}

	/**
	 * 获取获取用户注册信息
	 *
	 * @returns
	 *
	 * @memberOf ServiceDecision
	 */
	public async getRegisterInfo(data: any): Promise<any> {
		return await this.get('/userService/getRegisterInfo', data);
	}
}

export default new ServiceCas();
